<template>
  <div class="main-wrap">
    <el-radio-group v-model="tabPosition" style="margin-bottom: 30px; margin-top: 10px;margin-left: 10px;border-radius: 20px;">
      <el-radio-button label="cargoStatistics">{{$lang('货量统计')}}</el-radio-button>
      <el-radio-button label="finance">{{$lang('月结统计')}}</el-radio-button>
      <el-radio-button label="claimsSettlement">{{$lang('理赔统计')}}</el-radio-button>
      <div style="display: flex;justify-content: flex-end; margin-right: 50px;margin-top: -32px">
        <el-button @click="downloadCenterVisible = true" icon="el-icon-folder">{{$lang('下载中心')}}</el-button>
      </div>
    </el-radio-group>
    <CargoStatistics :tabPosition="tabPosition === 'cargoStatistics'" v-show="tabPosition === 'cargoStatistics'" />
    <Finance :tabPosition="tabPosition==='finance'" v-show="tabPosition==='finance'"/>
    <ClaimsSettlement :tabPosition="tabPosition==='claimsSettlement'" v-show="tabPosition==='claimsSettlement'"/>
    <DownloadCenter :visible="downloadCenterVisible" @handleClose="downloadCenterVisible = false"/>
  </div>
</template>

<script>
import CargoStatistics from '../dashboard/components/CargoStatistics'
import Finance from '../dashboard/components/Finance'
import ClaimsSettlement from '../dashboard/components/ClaimsSettlement'
import DownloadCenter from '../dashboard/components/DownloadCenter'

export default {
  name: 'Index',
  components: {
    CargoStatistics,
    Finance,
    ClaimsSettlement,
    DownloadCenter,
  },
  data() {
    return {
      tabPosition: 'cargoStatistics',
      downloadCenterVisible: false,
    }
  },
  methods: {

  },
}
</script>

<style scoped>

</style>
